var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg20Plus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20-plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0004 6.40088C16.6631 6.40088 17.2004 6.93814 17.2004 7.60088V14.8011H24.4004C25.0631 14.8011 25.6004 15.3383 25.6004 16.0011C25.6004 16.6638 25.0631 17.2011 24.4004 17.2011H17.2004V24.4009C17.2004 25.0636 16.6631 25.6009 16.0004 25.6009C15.3376 25.6009 14.8004 25.0636 14.8004 24.4009V17.2011H7.60039C6.93765 17.2011 6.40039 16.6638 6.40039 16.0011C6.40039 15.3383 6.93765 14.8011 7.60039 14.8011H14.8004V7.60088C14.8004 6.93814 15.3376 6.40088 16.0004 6.40088Z",
    fill: "#182BCF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20Plus);
export default __webpack_public_path__ + "static/media/20-plus.cc03167f83cc938aa583407618eb24da.svg";
export { ForwardRef as ReactComponent };